import { Plus, Tag } from "lucide-react";

import { Button } from "@/components/ui/button";

export function ChatSelectionBar({
    count,
    creating,
    onNewRequest,
    onCancel,
    onEditTopic,
}: {
    count: number;
    creating?: boolean;
    onNewRequest: () => void;
    onCancel: () => void;
    onEditTopic?: () => void;
}) {
    return (
        <div className="mx-2 mb-2 flex items-center justify-between gap-3 rounded-lg border border-zinc-200 bg-white px-3 py-2 shadow-xs">
            <span className="font-medium text-sm text-zinc-900">{count} selected</span>
            <div className="flex items-center gap-2">
                {onEditTopic && (
                    <Button variant="ghost" size="sm" onClick={onEditTopic}>
                        <Tag />
                        Edit topic
                    </Button>
                )}
                <Button size="sm" onClick={onNewRequest} disabled={creating}>
                    <Plus />
                    Request
                </Button>
                <Button variant="ghost" size="sm" onClick={onCancel}>
                    Cancel
                </Button>
            </div>
        </div>
    );
}
